import client from "../auth/client";

export const initialPostCall = async (
  feature: string,
  query: string,
  current_session: any,
  extra_data?: any
) => {
  const res = await client.post("/common/call_agent/", {
    feature: feature,
    query: query,
    current_session: current_session,
    extra_data: extra_data,
  });

  return res.data;
};

export const getChatHistory = async (params: Record<string, any>) => {
  const res = await client.post("/common/get_chat_history/", params);

  return res.data;
};

export const cleanChatHistory = async () => {
  const res = await client.post("/common/clear_chat_history/");

  return res.data;
};

export const getPreviousConversations = async () => {
  // const data = new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve([
  //       {
  //         session_id: "be799963-d276-4f14-87d8-97c23a7f2f78",
  //         title: "Untitled",
  //         created_at: "2025-07-01T13:14:19.993427Z",
  //         latest_message: "Review Contract which is drafted now",
  //       },

  //       {
  //         session_id: "be799963-d276-4f14-87d8-97c23a7f2f78",
  //         title: "Untitled",
  //         created_at: "2025-07-01T13:14:19.993427Z",
  //         latest_message: "Review Contract which is drafted now",
  //       },
  //       {
  //         session_id: "be799963-d276-4f14-87d8-97c23a7f2f78",
  //         title: "Untitled",
  //         created_at: "2025-07-01T13:14:19.993427Z",
  //         latest_message: "Review Contract which is drafted now",
  //       },
  //     ]);
  //   }, 1500);
  // });
  // return data;
  const res = await client.post("common/get_chat_history/", {});
  return res.data;
};

export const sendMessageToOrion = async (params: {
  session_id?: string;
  agent: string;
  message: string;
}) => {
  const payload: any = {
    agent: params.agent,
    message: params.message,
  };

  // Only include session_id if it exists
  if (params.session_id) {
    payload.session_id = params.session_id;
  }

  const res = await client.post("/sourcing_hub/send_message/", payload);
  return res.data;
};

export const generateRequirementsDocument = async (params: {
  sourcing_request_title: string;
  building_address: string;
  clearance_level: string;
  template_type: string;
  short_description?: string;
  total_contract_value?: string;
}) => {
  const res = await client.post(
    "/sourcing_hub/agent/generate_requirements_document/",
    params
  );
  return res.data;
};

export const reviewDocument = async (params: { doc_id: string; tab?: string }) => {
  // Use different endpoint based on tab parameter
  // If tab is "review_inprogress" or "review_completed", use get_review_results endpoint
  // Otherwise use review_document endpoint
  const endpoint = (params.tab === "review_inprogress" || params.tab === "review_completed")
    ? "/sourcing_hub/review/get_review_results/"
    : "/sourcing_hub/review/review_document/";
  
  console.log("=== reviewDocument service called ===");
  console.log("params:", params);
  console.log("selected endpoint:", endpoint);
  
  const res = await client.post(endpoint, { doc_id: params.doc_id });
  console.log("reviewDocument response:", res.data);
  return res.data;
};

// Revalidate a review for a sourcing hub document (forces revalidation)
export const revalidateReviewDocument = async (params: { doc_id: string }) => {
  const endpoint = "/sourcing_hub/review/review_document/";
  const payload = { doc_id: params.doc_id, revalidate: true };
  const res = await client.post(endpoint, payload);
  return res.data;
};
